import { OrgAdminRoleType } from '@/const/user';
import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type CreateInternalOrganizationUserPayloadType = {
  email: string;
  mobile_phone: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
  role: OrgAdminRoleType;
};

export const createInternalOrganizationUserApi = async (
  data: CreateInternalOrganizationUserPayloadType
): Promise<ApiResponseType<CreateInternalOrganizationUserPayloadType>> => {
  const uri = '/organization/internal/users/';

  return authApiService.POST(uri, data);
};
